<template>
  <div
    class="
      card card-radius
      shadow-sm
      bg-secondary
      text-center
      position-relative
      card__cobs
      pt-2
      pb-2
    "
  >
    <div class="card__selection">
      <input type="checkbox" @change="handleCheck" />
      <div
        @click="handleFakeCheck"
        :class="
          model
            ? 'radio selection__custom radio--checked'
            : 'radio selection__custom'
        "
      ></div>
    </div>
    <div class="standar-plus">
      <div class="card__title m-3">
        <h4 class="text-dark fw-bold font-title">
          <span style="color: #29abe2 !important">{{ price }} MXN</span>
        </h4>
        <p class="font-label" style="color: #757575 !important">
          Pago {{ title }} {{ getTypePayment() }}
        </p>
        <hr v-if="title !== 'CONTADO'" />
        <div v-if="title !== 'CONTADO'">
          <p class="font-label">
            Primer: <span class="fw-bold">${{ pricesub }} MXN</span>
          </p>
          <p class="font-label">
            Subsecuente: <span class="fw-bold">${{ subsecuente }} MXN</span>
          </p>
        </div>
      </div>
    </div>
    <div class="responsive-plus">
      <div class="card__title">
        <table>
          <tr>
            <td>
              <h2 class="text-dark fw-bold font-title p-3">
                <span style="color: #29abe2 !important">{{ price }} MXN</span>
              </h2>
            </td>
            <td style="border-left: 2px solid rgba(0, 0, 21, 0.2);" class="p-3">
              <label class="font-label" style="color: #757575 !important">
                Pago {{ title }} {{ getTypePayment() }}
              </label>
              <div v-if="title !== 'CONTADO'">
                <label class="font-label">
                  Primer: <span class="fw-bold">${{ pricesub }} MXN</span>
                </label>
                <label class="font-label">
                  Subsecuente:
                  <span class="fw-bold">${{ subsecuente }} MXN</span>
                </label>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    price: String,
    pricesub: String,
    subsecuente: String,
    title: String,
    model: Boolean,
    changePlan: Function,
    index: Number,
  },
  methods: {
    handleCheck(e) {
      this.removeChecks().then((_) => {
        const check = e.target;

        const customCheck =
          check.parentElement.querySelector(".selection__custom");

        if (!customCheck.classList.contains("radio--checked")) {
          customCheck.classList.add("radio--checked");
          check.checked = true;
          this.changePlan(this.index);
        }
      });
    },
    handleFakeCheck(e) {
      this.removeChecks().then((_) => {
        const fakeCheck = e.target.classList.contains("fa")
          ? e.target.parentElement
          : e.target;

        const input = fakeCheck.parentElement.querySelector("input");

        if (!fakeCheck.classList.contains("radio--checked")) {
          fakeCheck.classList.add("radio--checked");
          input.checked = true;
          this.changePlan(this.index);
        }
      });
    },
    getRoute(src) {
      if (!src) {
        return;
      }

      return src;
    },
    removeChecks() {
      return new Promise((resolve, _) => {
        const selectors = document.querySelectorAll(".selection__custom");
        selectors.forEach((selector, index) => {
          selector.classList.remove("radio--checked");

          if (index === selectors.length - 1) {
            resolve();
          }
        });
      });
    },
    getTypePayment() {
      switch (this.title) {
        case "CONTADO":
          return "(Pago Único)";
        case "SEMESTRAL":
          return "(Dos Pagos)";
        case "TRIMESTRAL":
          return "(Cuatro Pagos)";
        case "MENSUAL":
          return "(Doce Pagos)";
        default:
          return "";
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.card__image {
  width: 80px;
  height: 80px;
  img {
    max-height: 100%;
  }
}
.card__cobs {
  width: calc(50% - 5px);
  //   min-width: 150px;
  margin-bottom: 10px;
}
@media only screen and (min-width: 720px) {
  .card__cobs {
    width: calc(30% - 10px);
    min-width: 150px;
    margin: 0 10px 20px 10px;
  }
}
@media only screen and (min-width: 1000px) {
  .card__cobs {
    width: calc(25% - 20px);
    min-width: 150px;
    margin: 0 10px 20px 10px;
  }
}
.card-radius {
  background-color: white !important;
  border-radius: 30px !important;

  .card__selection {
    input {
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .card__icon {
    font-size: 40px;
  }
  .card__title {
    h4 {
      font-size: 18px;
    }
  }
  .card__desc {
    p {
      font-size: 12px;
    }
  }
}

.radio {
  width: 20px;
  height: 20px;
  background-color: #f4f5f7;
  border: 1px solid gray;
  position: absolute;
  right: -5px;
  top: -5px;
  border-radius: 50%;

  .fa {
    display: none;
  }
}
.radio--checked {
  background-color: #00db23 !important;
  border: 1px solid #47bc1e !important;
  .fa {
    display: block !important;
    color: white;
    font-size: 14px;
    padding-top: 2px;
  }
}
</style>